/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useEffect, useState } from "react";
import { fileUploadSources, optionsViewType } from "@Features/portal-settings";
import { formSectionType, getUrlFromField } from "./constants";
import { FormControl, FormHelperText } from "@mui/material";
import _ from "lodash";
import { getProjectTeamsUrl, locationUrl } from "@Services/dataManager";
import { QueryBuilder, executeQuery } from "@Services/queryBuilder";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_WARNING } from "@Services/constants";
import { ValidationWrapperWeb } from "@Features/forms";
import AddURLModal from "./addURLModal";
import { FileManagerAsPopup } from "@Features/files";
import AddGeoLocation from "./addGeoLocationModal";
import useQuestionFields from "./useQuestionFields";
import { fieldRenderers, getFieldAns } from "./questionFieldsHelper";
import { RootState } from "@Reducers/index";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { t } from "@i18n";
import { EmbeddedViewer } from "@Features/design-viewer";
import AddUser from "./addUserModal";

type SelectedFormFile = {
  fileVersion: string;
  fileId: string;
  resourceType: string;
  versionNumber: number;
  name: string;
};

const FormQuestionFields = (props: any) => {
  const {
    eachField,
    fieldIndex = null,
    sectionIndex = null,
    section = {},
    source = formSectionType.FORM,
    tableRowIndex = 0,
    tableRowId = null,
    disabled = false,
    handleCustomFieldData = null,
    showAnswersOnly = false,
    formData = {},
    userDetails = {},
    handleInputChange,
    handleChangeAnswer,
    handleURLModalState,
    handleSaveUrlData,
    showUrlModal = {},
    spaceId,
    showGeoLocationModal = {},
    setShowGeoLocationModal,
    extraParams = {},
    templateSource,
    showAddUsersModal = {},
    closeUsersModal,
    handleAddUserClick,
    openAddUserModal,
  }: any = props;
  const params = useParams() as { projectId: string };
  const dispatch = useDispatch();
  const lookUpQuery = new QueryBuilder().addParams("projectId", params.projectId);
  const userId = userDetails.id;
  const [teamsData, setTeamsData] = useState<any[]>([]);
  const [locationData, setLocationData] = useState<any[]>([]);
  const [showFileManager, setShowFileManager] = useState(false);
  let formValidator = props.formValidator || {};
  const tempFormValidator = useSelector((state: RootState) => state.formValidatorStore);
  if (!formValidator.validate) {
    formValidator = tempFormValidator;
  }
  const {
    _id,
    fieldType,
    lookUpAnsFieldType,
    minFieldRange,
    maxFieldRange,
    viewType = optionsViewType.LIST,
    selectionScope,
    defaultValue = null,
    uploadSource = fileUploadSources.LOCAL,
    openIn,
  }: any = eachField;

  const {
    questionId,
    name,
    sectionId,
    currentAnswer,
    enabled,
    setOpenUrlPopUpState,
    openUrlPopUpState = {},
    formulaValue,
    concatenatedValue,
  }: any = useQuestionFields({
    eachField,
    tableRowId,
    extraParams,
    section,
    tableRowIndex,
    source,
    formData,
    userId,
    disabled,
    showAnswersOnly,
    templateSource,
  });

  const getTeamsData = async (): Promise<void> => {
    const res: any = await executeQuery(getProjectTeamsUrl, lookUpQuery);
    const modifiedData = Array.isArray(res?.result)
      ? res.result.map((team: { _id: string; name: string }) => ({
          id: team._id,
          name: team.name,
        }))
      : [];
    setTeamsData(modifiedData);
  };

  const getLocationData = async (): Promise<void> => {
    const res: any = await executeQuery(locationUrl, lookUpQuery);
    const modifiedData = Array.isArray(res?.result)
      ? res.result.map((item: any) => ({
          ...item,
          id: item._id,
          label: item.name,
          parentId: item.parentId ?? null,
        }))
      : [];
    setLocationData(modifiedData);
  };

  useEffect(() => {
    if (fieldType !== "look-up") return;
    if (lookUpAnsFieldType === "Teams" && params.projectId) {
      getTeamsData();
    }
    if (lookUpAnsFieldType === "Location" && params.projectId) {
      getLocationData();
    }
  }, [fieldType, lookUpAnsFieldType, params.projectId]);

  useEffect(() => {
    if (defaultValue) {
      formValidator.validate({ name, value: defaultValue });
    }
  }, [defaultValue]);

  const getMultiSelectAnswer = (args: any) => {
    if (viewType === optionsViewType.LIST) {
      const prevAns = currentAnswer?.value || [];
      return args.target.checked
        ? [...prevAns, args.target.name]
        : prevAns.filter((ans: string) => ans !== args.target.name);
    }
    return args.target.value;
  };

  const getDateTimeAnswer = (args: any) => {
    if (selectionScope === "currentDateTime") {
      return { answerValue: Date.now(), status: true };
    }
    let dateVal: any = null;
    if (_.get(args, "$d")) {
      dateVal = new Date(args.$d).getTime();
    } else if (args?.value instanceof Date) {
      dateVal = args.value.getTime();
    }
    if (
      (minFieldRange && dateVal && dateVal < minFieldRange) ||
      (maxFieldRange && dateVal && dateVal > maxFieldRange)
    ) {
      return { answerValue: null, status: false, error: "Invalid date cannot be saved" };
    }
    if (Number.isNaN(dateVal)) {
      return { status: false };
    }
    return { answerValue: dateVal, status: true };
  };
  const getLookUpAnswer = (args: any) => {
    if (lookUpAnsFieldType === "Teams") return args;

    if (lookUpAnsFieldType === "Location") {
      const prevAns = currentAnswer?.value || [];
      return [...prevAns, { id: args.itemData.id, name: args.itemData.name }];
    }

    return currentAnswer?.value || [];
  };

  const getFileUploadAnswer = (args: any, currentAnswer?: any) =>
    Array.isArray(currentAnswer?.value) ? [...currentAnswer.value, ...args.answer] : [...args.answer];

  const getAnswer = (args: any) => {
    let output: any = { answerValue: "", status: true };

    if (["single-line", "multi-line", "single-select"].includes(fieldType)) {
      output.answerValue = args.target.value;
    } else if (fieldType == "multi-select") {
      output.answerValue = getMultiSelectAnswer(args);
    } else if (fieldType == "number") {
      const rawValue = args.target.value.replace(/,/g, "");
      output.answerValue = rawValue === "" ? null : Number(rawValue);
    } else if (fieldType == "date-time") {
      const result = getDateTimeAnswer(args);
      if (!result.status) {
        return result;
      }
      output.answerValue = result.answerValue;
    } else if (fieldType == "look-up") {
      output.answerValue = getLookUpAnswer(args);
    } else if (fieldType == "fileUpload" && uploadSource === fileUploadSources.FILE_MANAGER) {
      output.answerValue = getFileUploadAnswer(args);
    } else if (fieldType == "geoLocation") {
      output.answerValue = args;
    }
    return output;
  };

  const handleOnBlur = (args: any) => {
    const res = getAnswer(args);
    if (res.status) {
      if (formData._id) {
        handleInputChange({
          answerValue: res.answerValue,
          fieldIndex,
          sectionIndex,
          eachField,
          section,
          tableRowIndex,
          source,
        });
      }
    } else {
      dispatch(
        showToastNotification({
          content: res.error,
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
  };

  const handleOnChange = (args: any) => {
    const res = getAnswer(args);

    if (formValidator?.validate) {
      formValidator.validate({ name, value: res.answerValue });
    }
    if (res.status) {
      if (handleChangeAnswer) {
        handleChangeAnswer({
          source,
          answerValue: res.answerValue,
          fieldIndex,
          sectionIndex,
          questionId,
          tableRowIndex,
        });
      }
      if (handleCustomFieldData) {
        handleCustomFieldData({
          args: extraParams,
          eachField,
          answerValue: res.answerValue,
          fieldIndex,
          sectionIndex,
          tableRowIndex,
          source,
        });
      }
    }
  };

  const handleFileUploadClick = () => {
    if (uploadSource == fileUploadSources.LOCAL) {
      document.getElementById(`${name}`)?.click();
    } else {
      setShowFileManager(true);
    }
  };

  const handleUrlFieldClick = () => {
    const url = getUrlFromField(_.get(currentAnswer, "value.URL", ""));
    if (openIn == "popUp") {
      setOpenUrlPopUpState({ state: true, url, uniqueId: name });
    } else if (openIn == "sameTab") {
      window.location.href = url;
    } else {
      window.open(url);
    }
  };

  const handleRemoveLocation = () => {
    handleOnChange(null);
    handleOnBlur(null);
  };

  const getFieldAnsComponent = () => {
    const renderer = fieldRenderers[fieldType];
    const fieldComponent = renderer ? (
      renderer({
        ...props,
        projectId: params.projectId,
        formValidator,
        questionId,
        name,
        sectionId,
        currentAnswer,
        enabled,
        formulaValue,
        concatenatedValue,
        handleOnChange,
        handleOnBlur,
        handleRemoveLocation,
        lookUpQuery,
        teamsData,
        locationData,
        handleFileUploadClick,
        handleUrlFieldClick,
        openAddUserModal,
        formData,
        source,
      })
    ) : (
      <></>
    );

    const showCustomValidation = ["look-up", "users", "fileUpload", "image", "url", "geoLocation"].includes(fieldType);

    return showCustomValidation ? (
      <ValidationWrapperWeb value={currentAnswer.value} name={name} validator={formValidator}>
        {fieldComponent}
      </ValidationWrapperWeb>
    ) : (
      <FormControl fullWidth error={!!_.get(formValidator, `error.${name}`)}>
        {fieldComponent}
        {!!_.get(formValidator, `error.${name}`) && (
          <FormHelperText sx={{ marginInlineStart: 0 }}>{_.get(formValidator, `error.${name}`)}</FormHelperText>
        )}
      </FormControl>
    );
  };

  const handleFileSelectedCancelClick = () => {
    setShowFileManager(false);
  };

  const handleFileSelectedButtonClick = (args: any) => {
    const selectedFiles: SelectedFormFile[] = Object.values(args).map((file: any) => ({
      fileVersion: file.fileVersion,
      fileId: file.hierarchyId,
      resourceType: file.resourceType,
      versionNumber: file.versionNumber,
      name: file.name,
    }));
    const answer = [...((currentAnswer?.value as SelectedFormFile[]) || []), ...selectedFiles];
    handleOnChange({ answer });
    handleOnBlur({ answer });
    handleFileSelectedCancelClick();
  };

  const handleSaveLocation = ({ current, selected, mapZoomLevel }: any) => {
    if (showGeoLocationModal?.eachField?.allowManualSelection) {
      handleOnChange({ current, selected, mapZoomLevel });
      handleOnBlur({ current, selected, mapZoomLevel });
    } else {
      handleOnChange({ current, selected: current, mapZoomLevel });
      handleOnBlur({ current, selected: current, mapZoomLevel });
    }
    setShowGeoLocationModal({ state: false });
  };
  return (
    <>
      {showAnswersOnly
        ? getFieldAns(props, currentAnswer, handleUrlFieldClick, params.projectId)
        : getFieldAnsComponent()}
      {showFileManager && (
        <FileManagerAsPopup
          projectId={params.projectId}
          handleFileSelectedButtonClick={handleFileSelectedButtonClick}
          handleFileSelectedCancelClick={handleFileSelectedCancelClick}
          workspaceId={spaceId}
          selectedFilesData={currentAnswer.value}
          hideIssues
          hideTasks
          hideEstimates
          hideSchedules
          hideContracts
          hideExternalSpace
          enableFilesTypes={["RESOURCE_TYPE_FILE", "RESOURCE_TYPE_FOLDER", "RESOURCE_TYPE_MERGED_FILE"]}
        />
      )}
      {showUrlModal?.state && name === showUrlModal.uniqueId && (
        <AddURLModal
          showUrlModal={showUrlModal}
          handleCustomFieldData={handleCustomFieldData}
          handleURLModalState={handleURLModalState}
          handleSaveUrlData={handleSaveUrlData}
          name={name}
        />
      )}
      {showGeoLocationModal?.state && name == showGeoLocationModal.uniqueId && (
        <AddGeoLocation
          setShowGeoLocationModal={setShowGeoLocationModal}
          showGeoLocationModal={showGeoLocationModal}
          handleSaveLocation={handleSaveLocation}
          name={name}
        />
      )}
      {openUrlPopUpState.state && openUrlPopUpState.uniqueId === name && (
        <ModalStateDialogComponent
          headerTitle={<div className="flex justify-between w-full">{t("View Url")}</div>}
          modelContent={<EmbeddedViewer id={_id} embedUrl={openUrlPopUpState.url} />}
          width="95%"
          height="95%"
          onCancel={() => setOpenUrlPopUpState({ state: false, url: "" })}
          isVisible={openUrlPopUpState.state}
        />
      )}
      {showAddUsersModal.status && name === showAddUsersModal.uniqueId && (
        <AddUser
          currentUsers={
            showAddUsersModal.source == formSectionType.TABLE_SECTION
              ? (section.tableDataSource[showAddUsersModal.tableRowIndex]?.[showAddUsersModal.fieldData._id]?.value ??
                [])
              : (showAddUsersModal.fieldData?.answer?.value ?? [])
          }
          closeUsersModal={closeUsersModal}
          handleAddUserClick={handleAddUserClick}
          fieldData={eachField}
          section={section}
          formId={formData._id}
          spaceId={spaceId}
          projectId={params.projectId}
          handleCustomFieldData={handleCustomFieldData}
        />
      )}
    </>
  );
};
export default FormQuestionFields;
